import { render } from "./report_input_past_component.vue?vue&type=template&id=28fc9a38&scoped=true"
import script from "./report_input_past_component.vue?vue&type=script&scoped=true&lang=js"
export * from "./report_input_past_component.vue?vue&type=script&scoped=true&lang=js"

import "./report_input_past_component.vue?vue&type=style&index=0&id=28fc9a38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28fc9a38"]])

export default __exports__